export type FormatType = 'custom' | 'currency' | 'date' | 'time'
